export default "__VITE_ASSET__DLz1Fp9R__"